import ErrorBoundary from 'components/ErrorBoundary';
import React, { useEffect, useState } from 'react'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Card, CardBody, Col, Container, Row, Button } from 'reactstrap'


import SearchContainer from './SearchContainer';
import { cloneDeep, find } from 'lodash';
import plus from 'assets/icon/plus-icon.svg';
import Drawer from 'components/Drawer';
import Add from './CaseManagementTable/index';
import CaseManagementTable from './CaseManagementTable';
import useContextService from 'hooks/useContextService';
import useAxios from 'hooks/useAxios';
import { ModuleAccess } from 'utils/moduleaccess';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import ViewCaseDetails from './CaseDetails';

import SortDown from 'assets/icon/Sort_Down.svg';
import Sortup from 'assets/icon/Sort_Up.svg';
import { onExport } from 'utils/helper';
import Loader from 'components/Loader';


let filters = [];
let filterReports = []
let revalues = {};
let configdata = []
// let reportsdata=[]
const CaseManagement = () => {
    const { token_type, access_token, profile } =
        JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const { roles } = profile || {};
    const [key, setkey] = useState('reports');
    const {
        states: { configuration, reports },
        setStates,
    } = useContextService();


    const API = useAxios();

    const [reset, setReset] = useState(false);
    const [collapseSider, setcollapseSider] = useState(false);
    const [selectedcoveredEntity, setselectedCoveredEntity] = useState(false)
    const { search, coveredEntity, searchTerms, claimStatusID } = configuration;
    const { Search, SearchTerms } = reports
    const [data, setData] = useState([])
    const [reportsdata, setReportsData] = useState([])
    const [totalItem, setTotalItem] = useState(0);
    const [totalItemReport, setTotalItemReport] = useState(0);
    const [loading, setLoading] = useState(false)
    const [filtershow, setFilterShow] = useState(false)
    const [configFiltershow, setConfigFilterShow] = useState(false)
    const [startPage, setStartPage] = useState(null)
    const [reportStartPage, setReportStartPage] = useState(null)
    const [collIcon, setCollIcon] = useState(faAngleUp);
    const [celist, setCelist] = useState()
    const [columnFilters, setColumnFilters] = useState([]);

    const [selectedValues, setSelectedValues] = useState({
        claimTypeDesc: '',
        frequencyDesc: '',
    });
    const [selectedStatusValues, setSelectedStatusValues] = useState('')
    const [openPharmacy, setOpenPharmacy] = useState(false);
    //const [resetFilter, setResetFilter] = useState(false)
    const [sort, setSort] = useState(false)
    const [sortConfig, setSortConfig] = useState(false)
    const [toogleview, settoogleView] = useState(false)
    const [selectedRow, setselectedRow] = useState({});
    const [resetfilter, setResetFilter] = useState(0)

    const [caseAttachment, setAttachment] = useState([])
     const updateStates = (all) => {
    setStates(all, all);
  };
    // console.log(Sortup,"SortDown")

    const manval = () => {
        setcollapseSider(!collapseSider);
    }

    const handleExport = () => {
        const { access_token } =
            JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_API_ENDPOINT}/api/Search/export/?access_token=${access_token}`;
        onExport(action, search);
    }

    const fetchConfiguration = async (filters) => {
        setLoading(true)
        try {
            //  if (filters.ApplicationId && filters.ReportTypeId &&filters.coveredEntityIDs) {
            const { data } = await API.post(`api/Search/casedetails`, filters,
                {
                    hasDefaultURL: true,
                });
            if (data) {
                // setcollapseSider(true);
                configdata.push(data.items);
                setData(data.items)
                setTotalItem(data.totalRecords);
                setLoading(false)
            } else {
                configdata = []
                setData([])
                setTotalItem(0);
                setLoading(false)
            }
        } catch (error) { setLoading(false) }
    };

    const handleSearch = async (filter, hasfilter) => {
    debugger;
        revalues = filter;
        configuration.search.currentPage = 1;
        configuration.search.orderBy = "openDate";
        const {
            ceCode,
            startDate,
            loginID,
            ceCodes,
            endDate,
            CaseStatus,
        } = filter;
        Object.keys(filter).map((key) => {
            const index = filters.findIndex(
                (item) => item.filterName === key && key != 'dateOfService'
            );
            filters.splice(index, 1);
        });

        const tableRes = document.querySelector('.table-responsive');
        tableRes.scrollLeft = 0;
        search.filters = filters;
        search.loginID = loginID;
        search.ceCodes = ceCode?ceCode:ceCodes;
        search.startDate = startDate;
        search.endDate = endDate;
        search.CaseStatus=CaseStatus
        if(search.ceCodes){
        await fetchConfiguration(search);

        }
        setStartPage(2)
    };

    const refetch = () => {
        // debugger;
        setColumnFilters([]);
        // handleSearch(revalues);
    };
     
  const handelrefecth = (hasvalue) => {
    debugger;
    configuration.filters = [];
    configuration.currentPage = 1;
    setColumnFilters([]);
    if (hasvalue) {
      fetchConfiguration(search);
    }
    updateStates(configuration);
  };
    const handleReset = () => {
        debugger;
                configuration.search.ceCodes=[]
        
        setcollapseSider(false);
        setData([]);
        //filters = []
        setConfigFilterShow(false)
        setTotalItem(0);
        setSort(false)
    };
    console.log(data,"data")

    const handlePageChange = (filter, haveColFilter) => {

        if (haveColFilter) {
            const filterObj = cloneDeep(search);
            filterObj.filters = [...filterObj.filters, ...filter.filters];
            filterObj.currentPage = filter.currentPage;
            filterObj.pageSize = filter.pageSize;
            filterObj.order=filter.order
            filterObj.orderBy=filter.orderBy
            configuration.search.currentPage = filter.currentPage;
            configuration.search.pageSize = filter.pageSize;
            configuration.search = { ...configuration.search };
            fetchConfiguration(filterObj);
        }
        else {
            if (totalItem > 0)
                fetchConfiguration(filter);
            configuration.search = { ...configuration.search, ...filter };
        }
        setStates('configuration', configuration);
    };

    const hasPermission = (code) => {
        return ModuleAccess("ClaimsConnect", code)
    }

    const toggleSider = () => {
        setcollapseSider(!collapseSider);
        if (!collapseSider) {
            setCollIcon(faAngleDown);
        }
        else {
            setCollIcon(faAngleUp);
        }
    }

    const handleSearchColumnFilters = async (columnFilters) => {

        const filterObj = cloneDeep(search);
        if (columnFilters && columnFilters.length > 0) {
            filterObj.filters = [...filterObj.filters, ...columnFilters];
            setColumnFilters(columnFilters);
        }
        await fetchConfiguration(filterObj);
    };

    const handleSearchColumnFiltersClear = () => {
        setColumnFilters([]);
    };
    console.log(toogleview, "toggleview",caseAttachment)
    return (
        <div>
                  {loading && <Loader opacity={0.01} color='black' />}

            <Container fluid className='my-3 width_info' >

                <ViewCaseDetails
                    loading={loading}
                    setLoading={setLoading}
                    toogleview={toogleview}
                    settoogleView={settoogleView}
                    selectedRow={selectedRow}
                    caseAttachment={caseAttachment}
                    setAttachment={setAttachment}
                    handleSearch={handleSearch}
                    filters={search}

                />
                <div hidden={toogleview}>
                    <div className={collapseSider ? "mb-0" : "mb-3"}>
                        <div className='border-0 shadow-top card'>
                            <div hidden={collapseSider} className='card-body'>
                                <SearchContainer onSearch={handleSearch} onReset={handleReset} setStartPage={setStartPage} toogleview={toogleview}
                                    settoogleView={settoogleView} sort={sortConfig} 
                                    //  refetch={refetch}
                                    setSort={setSortConfig} setResetFilter={setResetFilter}
                                    loading={loading}setLoading={setLoading}
                                    tabledata={data}
                                    setDatatable={setData}

                                />
                            </div>
                        </div>
                    </div>

                    <div className='border-0 shadow-top card mt-3'>
                        <div className='section-devider-border card-body'>

                            <CaseManagementTable
                                loading={loading}
                                manval={manval}
                                data={data}
                                filters={search}
                                setFilterShow={setConfigFilterShow}
                                filtershow={configFiltershow}
                                onSearch={handleSearch}
                                onPageChange={handlePageChange}
                                totalSize={totalItem}
                                fetchConfiguration={fetchConfiguration}
                                startPage={startPage}
                                setStartPage={setStartPage}
                                selectedValues={selectedValues}
                                setSelectedValues={setSelectedValues}
                                ceid={searchTerms.coveredEntityIDs}
                                sort={sortConfig}
                                setSort={setSortConfig}
                                toggleSider={toggleSider}
                                collapseSider={collapseSider}
                                onSearchColumnFilters={handleSearchColumnFilters}
                                onSearcgColumnFiltersClear={handleSearchColumnFiltersClear}
                                refetch={handelrefecth}
                                toogleview={toogleview}
                                settoogleView={settoogleView}
                                selectedRow={selectedRow}
                                setselectedRow={setselectedRow}
                                resetfilter={resetfilter}
                                handleExport={handleExport}
                                setAttachment={setAttachment}
                                caseAttachment={caseAttachment}


                            // toggle={toggle}
                            />
                        </div>
                    </div>
                </div>

            </Container>
            {/* <Drawer
                direction='end'
                isOpen={openPharmacy}
                toggle={manvalPharmacy}
                size='lg'
                title='Add Configuration'
            >
                <Add
                    manvalPharacy={manvalPharmacy}
                    onSearch={handleSearch}
                    Loading={loading}
                    onSave={handlecoveredEntity}
                />
            </Drawer> */}
        </div>
    )
}

export default CaseManagement